<template>
    <div
      v-if="videos"
      class="page-content-wrapper"
    >
      <div
        v-if="showSlider"
        tabindex="1"
      >
        <swiper
          disabled
          ref="videoSlider"
          id="swiper-wrapper"
          :options="swiperOption"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          :key="$vs.rtl"
          @slideChange="slideChange"
        >
          <swiper-slide
            v-for="(video, index) in videos"
            :key="index"
          >
            <div
              class="slide-wrapper"
              :id="index"
            >
              <video-content :video="video" :index="index" :play-changed="playChanged" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
</template>

<script>
import VideoContent from './VideoContent'
export default {
  props: {
    videos: {
      type: Array
    }
  },
  name: 'VideoContentPages',
  components: {
    VideoContent
  },
  data () {
    return {
      showSlider: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: (this.isMobile) ? 0 : 15,
        slidesPerGroup: 1,
        loop: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        notNextTick: true,
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      canPlay: true
    }
  },
  mounted () {
    if (this.isMobile) {
      this.swiperOption.slidesPerView = 1
      this.swiperOption.loop = true
    }

    this.showSlider = true
  },
  computed: {
    isMobile () {
      return this.$store.state.api.isMobile
    },
    swiper () {
      return this.$refs.videoSlider.swiper
    }
  },
  watch: {},
  methods: {
    playChanged (isPlayed, index) {
      if (isPlayed) {
        this.swiper.slideTo(index + 1)
        this.swiper.autoplay.stop()
      } else {
        this.swiper.slideTo(index + 1)
        this.swiper.autoplay.start()
      }
    },
    contentClicked () {
    },
    slideChange () {
      if (this.swiper.activeIndex === this.videos.length + 1) {
        this.swiper.slideTo(1)
      }
    }
  }
}
</script>

<style lang="scss">
.page-content-image {
  height: 250px;
  width: 100%;
  border-radius: 10px;


  .vx-card__body {
    padding: 0 !important;
  }
}

.page-image-wrapper {
  width: 100%;
  height: 222px;
  background-size:cover;
  background-position: center;

}

@media (min-width: 860px) {
  .page-image-wrapper {
    height: 222px;
  }
}
</style>
